module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/General/Other#1-60dc3023d5b954e36d8ee646b512a10a.svg";